import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router';
import SupportPopUp from '@common/components/SupportPopUp';

function useSupportPopup() {
  const [showSupportPopup, setShowSupportPopup] = useState(false);

  const openSupportPopup = useCallback(() => {
    setShowSupportPopup(true);
  }, [setShowSupportPopup]);

  const closeSupportPopup = useCallback(() => {
    setShowSupportPopup(false);
  }, [setShowSupportPopup]);

  const location = useLocation();
  useEffect(() => {
    setShowSupportPopup(false);
  }, [location]);

  const supportPopup = useMemo(() => {
    if (showSupportPopup) {
      return <SupportPopUp hide={closeSupportPopup} />;
    }
    return undefined;
  }, [closeSupportPopup, showSupportPopup]);

  return {
    openSupportPopup,
    closeSupportPopup,
    supportPopup,
  };
}

export default useSupportPopup;
